import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledItemInstanceId = Brand<number, 'ScheduledItemInstanceId'>;
export const ScheduledItemInstanceId = createBranded<ScheduledItemInstanceId>();
